import { AudioLines } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { useOptionalDictation, useVoiceQueueCount } from '@/components/voice/DictationContext';

interface Props {
  /** Sidebar mobile aberta: some, pra não competir com o botão de dentro. */
  hidden?: boolean;
}

const PATIENT_FILE_RE = /^\/pacientes\/([^/?]+)/;

/**
 * FAB do "Ditar" no mobile (spec 009). Fica **acima** do FAB de gravação, que
 * mora em `bottom-4 left-4` — os dois são de voz e não podem se sobrepor. A
 * posição vem da pilha que o Shell monta (ditado embaixo, câmera em cima).
 *
 * Mesma regra de ativação dos vizinhos: só dispara dentro da ficha de um
 * paciente. Fora dela nem aparece (no mobile, espaço é caro demais pra gastar
 * com botão desabilitado).
 */
export const FloatingDictateButton = ({ hidden }: Props) => {
  const ctx = useOptionalDictation();
  const { pathname } = useLocation();
  const patientId = PATIENT_FILE_RE.exec(pathname)?.[1] ?? null;
  const queued = useVoiceQueueCount(patientId);

  if (!ctx || hidden) return null;
  if (patientId === null || !ctx.available) return null;

  return (
    <button
      type="button"
      onClick={() => ctx.open({ autoStart: 'live', origem: 'clique' })}
      title="Ditar documentos"
      aria-label="Ditar documentos"
      className="relative w-12 h-12 rounded-full flex items-center justify-center shadow-xl transition-all bg-primary text-on-primary hover:brightness-110 ring-2 ring-primary/30"
    >
      <AudioLines size={20} />
      {queued > 0 && (
        <span className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-error text-on-error text-[10px] font-bold flex items-center justify-center">
          {queued}
        </span>
      )}
    </button>
  );
};
